import {
  CropOriginal,
  DeleteOutline,
  AddCircleOutline,
  Clear,
} from "@material-ui/icons";
import Joi from "joi";
import strategy from "joi-validation-strategy";
import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Dropzone from "react-dropzone";
import InputMask from "react-input-mask";
import NumericInput from "react-numeric-input";
import validation from "react-validation-mixin";
import { StatesList } from "./../../../Helper/StatesList";
import BrokerageFees from "./BrokerageFees";
import Buyers from "./Buyers";
import $ from "jquery";
import APIUtil from "./../../../config/APIUtil";
import UrlConstants from "./../../../config/UrlConstants";
import {
  currencyFormat,
  formatPhoneNumber,
  formatNumber,
  cryptoTokenDecode,
} from "./../../Common/Common";
import * as code from "./../../../config/Constants";
import * as message from "./../../../config/CommonMessages";
import { connect } from "react-redux";
import Select from "react-select";
var _ = require("lodash");

class PropertyInfo extends React.Component {
  constructor(props) {
    super(props);
    let userType = cryptoTokenDecode().usertype;
    let currentType = localStorage.getItem("currentRole");
    let year = new Date()
      .getFullYear()
      .toString()
      .substr(-2);
    this.state = {
      nameBySystem: true,
      shortName: "DWRK" + year + Math.floor(1000 + Math.random() * 9000),
      draft: props.getTransactionData().draft,
      leadSource: props.getTransactionData().leadSource,
      emd: props.getTransactionData().emd || "0",
      agreedOpenPrice: props.getTransactionData().agreedOpenPrice,
      transactionType: props.getTransactionData().transactionType,
      property_image: props.getTransactionData().property.image,
      buyer_email: props.getTransactionData().buyer.email,
      buyer_firstname: props.getTransactionData().buyer.firstname,
      buyer_lastName: props.getTransactionData().buyer.lastname,
      buyer_mobileNumber: props.getTransactionData().buyer.mobileNumber
        ? props.getTransactionData().buyer.mobileNumber.toString()
        : props.getTransactionData().buyer.mobileNumber,
      acceptedFiles: props.getTransactionData().property.image,
      commission: 100,
      formerrors: undefined,
      shortNameAccepted: undefined,
      heldBy: props.getTransactionData().heldBy,
      salePriceFocus: false,
      emdFocus: false,
      buyers: props.getTransactionData().buyers,
      artist: props.getTransactionData().artist,
      isBuyerFormDisabled: true,
      listingAgents: props.getTransactionData().listingAgents,
      closingAgents: props.getTransactionData().closingAgents,
      closingAgentEdit: props.getTransactionData().closingAgentEdit,
      closing_agent_email: !!props.getTransactionData().closingAgents[0]
        ? !!props.getTransactionData().closingAgents[0].email
          ? props.getTransactionData().closingAgents[0].email.address
          : ""
        : "",
      closing_agent_mob: !!props.getTransactionData().closingAgents[0]
        ? props.getTransactionData().closingAgents[0].mobileNumber
        : "",
      nameErrClass: "",
      valErrClass: "",
      otherEMD: props.getTransactionData().otherEMD || [],
      draftedEMD: this.props.getTransactionData().draftedEMD || undefined,
      editData: {},
      isEdit: false,
      userTimezone: this.props.getTransactionData().userTimezone,
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      userType: userType.toUpperCase(),
      isClientUnder18: false,
      ownerId: this.props.getTransactionData().ownerId,
    };

    this.validatorTypes = function() {
      var base = Joi.object().keys({
        shortName: Joi.string(),
        emd: Joi.number()
          .min(0)
          .max(this.state.agreedOpenPrice),
        agreedOpenPrice: Joi.number()
          .min(0.001)
          .required(),
        transactionType: Joi.string().required(),
        // "buyer_email": Joi.string().regex(new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)).required(),
        // "buyer_firstname": Joi.string().required(),
        // "buyer_lastName": Joi.string().required(),
        // "buyer_mobileNumber": Joi.string().regex(new RegExp(/(?:1?|\+1|\+\s1|\(?)(?:\(?|\s\(|[\.\-\s])\d{3}(?:\)?|\)\s|[\.\-\s])\d{3}[\.\-\s]\d{4}/)).required(),
        commission: Joi.number(),
        closing_agent_email: Joi.string()
          .allow("")
          .regex(
            new RegExp(
              /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
            )
          ),
        closing_agent_mob: Joi.string()
          .allow("")
          .regex(
            new RegExp(
              /(?:1?|\+1|\+\s1|\(?)(?:\(?|\s\(|[\.\-\s])\d{3}(?:\)?|\)\s|[\.\-\s])\d{3}[\.\-\s]\d{4}/
            )
          ),
      });
      return base;
    };

    this.getValidatorData = this.getValidatorData.bind(this);
    this.renderHelpText = this.renderHelpText.bind(this);
    this.isValidated = this.isValidated.bind(this);
  }

  getValidatorData() {
    return {
      shortName: this.state.shortName,
      emd: this.props.getTransactionData().emd || "0",
      agreedOpenPrice: this.props.getTransactionData().agreedOpenPrice,
      transactionType: this.props.getTransactionData().transactionType,
      // "buyer_email": this.state.buyer_email,
      // "buyer_firstname": this.state.buyer_firstname,
      // "buyer_lastName": this.state.buyer_lastName,
      // "buyer_mobileNumber": this.state.buyer_mobileNumber ? this.state.buyer_mobileNumber.toString() : this.state.buyer_mobileNumber,
      // "commission": this.props.getTransactionData().commission,
      listingAgents: this.props.getTransactionData().listingAgents,
      closingAgents: this.props.getTransactionData().closingAgents,
      closing_agent_email: this.state.closing_agent_email,
      closing_agent_mob: !!this.props.getTransactionData().closingAgents[0]
        ? this.props.getTransactionData().closingAgents[0].mobileNumber
        : "",
    };
  }

  /**
   * @desc get error message based on field
   * @param {*} field
   * @param {*} errsList
   */
  getErrorMsg(field, errsList) {
    var err = "";
    // console.log("errsList", errsList);
    if (
      field === "emd" ||
      field === "agreedOpenPrice" ||
      field === "property_street" ||
      field === "property_city" ||
      field === "agreedOpenPrice" ||
      field === "buyer_firstname" ||
      field === "property_state" ||
      field === "buyer_lastName" ||
      field === "transactionType" ||
      field === "property_image" ||
      field === "commission" ||
      field === "shortName"
    ) {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        // if (field === "emd") {
        //   if (this.state.agreedOpenPrice < this.state.emd) {
        //     err = "Deposit can't be greater than total cost";
        //   } else {
        //     err = "Please enter deposit";
        //   }
        // }
        if (field === "property_street") {
          err = message.ENTER_ADDRESS_LINE;
        }

        if (field === "property_city") {
          err = message.ENTER_CITY;
        }
        if (field === "buyer_firstname") {
          err = message.ENTER_CLIENT_FIRST_NAME;
        }
        if (field === "buyer_lastName") {
          err = message.ENTER_CLIENT_LAST_NAME;
        }
        if (field === "agreedOpenPrice") {
          err = "Please enter total cost";
        }
        if (field === "property_state") {
          err = message.SELECT_STATE;
        }
        if (field === "transactionType") {
          err = "Please select an appointment type";
        }
        if (field === "property_image") {
          if (this.state.acceptedFiles.length <= 0) {
            err = "Please select an artwork image";
          }
        }
        if (field === "commission") {
          err = "Please enter commission";
        }
        if (field === "shortName") {
          err = "Please enter artwork ID";
        }
      }
    }

    if (field === "buyer_email") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_EMAIL;
        }
        if (errsList[field].length === 1) {
          err = message.ENTER_VALID_EMAIL;
        }
      }
    }
    if (field === "property_zipcode") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_ZIP;
        }
        if (errsList[field].length === 1) {
          err = message.ENTER_VALID_ZIP;
        }
      }
    }

    if (field === "buyer_mobileNumber") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_MOBILE_NUMBER;
        }
        if (errsList[field].length === 1) {
          err = message.MOBILE_10_DIGIT;
        }
      }
    }

    if (
      field === "shortName" &&
      ((this.state.shortNameAccepted !== undefined &&
        !this.state.shortNameAccepted) ||
        this.props.shortNameErr === "error")
    ) {
      err = "Transaction short name already exists. Please use another.";
    }

    if (field === "buyers") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 1) {
          err = "Please add a buyer.";
        }
      }
    }

    return err;
  }

  /**
   * @desc check form is valid or not
   */
  isValidated() {
    return new Promise((resolve, reject) => {
      this.props.validate((error) => {
        if (
          error ||
          (this.state.shortNameAccepted !== undefined &&
            !this.state.shortNameAccepted)
        ) {
          this.setState({ formerrors: error });
          // form contains errors
          reject();
          return false;
        }
        resolve();
        return true;
      });
    });
  }

  renderHelpText(message, id) {
    return (
      <div className="val-err-tooltip" key={id}>
        <span>{message}</span>
      </div>
    );
  }

  /**
   * @desc get default short name - Client feedback
   * format B, last 2 latter of year, first 3 of latter buyer 1s last name, first 3 latter of street name
   */
  getDefaultShortName() {
    let year = new Date()
      .getFullYear()
      .toString()
      .substr(-2);
    // let buyerLstName = this.state.buyer_lastName ? this.state.buyer_lastName.substring(0, 3) : "";
    let shortname = "DWRK" + year + Math.floor(1000 + Math.random() * 9000);
    this.props.checkShortName(shortname).then((res) => {
      if (res.isAccepted) {
        this.setState({ shortNameAccepted: true });
      } else {
        this.setState({ shortNameAccepted: false });
      }
    });
    return shortname;
  }

  /**
   * @desc set default short name while changing lastname of buyer
   */
  setDefaultShortName() {
    this.setState({ shortName: this.getDefaultShortName() });
    this.props.updateTransactionData("shortName", this.state.shortName);
  }

  /**
   * @desc on change event of field
   * @param {*} event
   */
  onChange(event) {
    if (
      event.target.name === "property_street" ||
      event.target.name === "buyer_lastName"
    ) {
      this.setState({ [event.target.name]: event.target.value }, () => {
        if (this.state.nameBySystem) {
          this.setState({ shortName: this.getDefaultShortName() });
          this.props.updateTransactionData(
            "shortName",
            this.getDefaultShortName()
          );
        }
      });
      this.props.updateTransactionData(event.target.name, event.target.value);
    } else {
      this.setState({ [event.target.name]: event.target.value });
      this.props.updateTransactionData(event.target.name, event.target.value);
    }
    //If zipcode is changed then get city and state from entered zicode
    if (event.target.name === "property_zipcode") {
      let enteredZip = event.target.value.toString();
      let zipcode = "";
      if (enteredZip.length > 5) {
        zipcode = enteredZip.replace(/\-/g, "");
      }
      if (
        event.target.value != "00000" &&
        (enteredZip.length == 5 || zipcode.length == 9)
      ) {
        this.props.getCityState(enteredZip).then((res) => {
          this.setState({ property_city: res.city, property_state: res.state });
          this.props.updateTransactionData("property_city", res.city);
          this.props.updateTransactionData("property_state", res.state);
        });
      } else {
        this.setState({ property_city: "", property_state: "" });
        this.props.updateTransactionData("property_city", "");
        this.props.updateTransactionData("property_state", "");
      }
    }
  }
  /**
   * @desc upload image for transcation
   * @param {*} files
   */
  uploadImage(files) {
    var acceptedFiles = this.state.acceptedFiles;
    acceptedFiles = _.uniqBy(_.concat(acceptedFiles, files), "name");
    this.setState({
      acceptedFiles,
      property_image: acceptedFiles,
    });
    this.props.handleValidation("property_image");
    this.props.updateTransactionData("property_image", acceptedFiles);
  }

  /**
   * @desc delete image
   * @param {*} i
   */
  deleteImage(i) {
    var acceptedFiles = this.state.acceptedFiles;
    acceptedFiles.splice(i, 1);
    this.setState(
      {
        acceptedFiles,
      },
      this.props.updateTransactionData(
        "property_image",
        this.state.acceptedFiles
      )
    );
  }

  getFormErrs() {
    return this.state.formerrors;
  }

  componentDidMount() {
    this.props.onRef(this);
    this.setDefaultShortName();
  }

  /**
   * @desc check default buyer data
   */
  checkDefaultBuyerData() {
    return this.state.buyer_email !== "" ? true : false;
  }

  /**
   * @desc check buyer email is exist or not
   * @param {*} email
   * @param {*} errors
   */
  checkBuyerEmail(email, errors) {
    this.setState({ buyer_email: email });
    this.props.updateTransactionData("buyer_email", email);
    if (email === "") {
      this.setState({
        buyer_mobileNumber: "",
        buyer_firstname: "",
        isBuyerFormDisabled: false,
        buyer_lastName: "",
        defaultBuyerErr: false,
      });
      this.props.updateTransactionData("buyer_mobileNumber", "");
      this.props.updateTransactionData("buyer_firstname", "");
      this.props.updateTransactionData("buyer_lastName", "");
    } else {
      APIUtil.getMethod(
        UrlConstants.emailCheckUrl + "?email=" + email,
        false
      ).then((response) => {
        if (response.data && response.data._id !== undefined) {
          if (Object.keys(response.data).length > 0) {
            this.setState({
              buyer_mobileNumber: formatPhoneNumber(response.data.mobileNumber),
              buyer_firstname: response.data.firstname,
              isBuyerFormDisabled: true,
              buyer_lastName: response.data.lastname,
            });
            this.props.updateTransactionData(
              "buyer_mobileNumber",
              formatPhoneNumber(response.data.mobileNumber)
            );
            this.props.updateTransactionData(
              "buyer_firstname",
              response.data.firstname
            );
            this.props.updateTransactionData(
              "buyer_lastName",
              response.data.lastname
            );
            // this.setDefaultShortName()
          } else {
            this.setState({
              buyer_mobileNumber: "",
              buyer_firstname: "",
              isBuyerFormDisabled: false,
              buyer_lastName: "",
              defaultBuyerErr: false,
            });
            this.props.updateTransactionData("buyer_mobileNumber", "");
            this.props.updateTransactionData("buyer_firstname", "");
            this.props.updateTransactionData("buyer_lastName", "");
          }
        } else {
          this.setState({
            buyer_mobileNumber: "",
            buyer_firstname: "",
            isBuyerFormDisabled: false,
            buyer_lastName: "",
            defaultBuyerErr: false,
          });
          this.props.updateTransactionData("buyer_mobileNumber", "");
          this.props.updateTransactionData("buyer_firstname", "");
          this.props.updateTransactionData("buyer_lastName", "");
        }
      });
    }
  }

  //delete fees record
  deleteFeesRecord(feesIndex) {
    let fees = this.state.otherEMD;
    if (feesIndex !== "") {
      delete fees[feesIndex];
      var ar = fees.filter(function(el) {
        return el != null;
      });

      this.setState({ otherEMD: ar });
      this.props.updateTransactionData("otherEMD", ar);
      this.props.updateTransactionData("updatedEMD", []);
    }
  }

  //edit fees record
  editFeesRecord(feesIndex) {
    let fees = this.state.otherEMD;
    let selfee = fees[feesIndex];
    selfee.ind = feesIndex;
    this.setState({ editData: selfee, isEdit: true });
  }

  //update fees record
  updateFeesRecord() {
    let fees = this.state.otherEMD;
    let ind = this.state.editData.ind;

    let feeLabel = $(".other-deposit-label ul li.title input").val();
    let feeVal = $(".other-deposit-label .value input").val();

    if (feeLabel !== "" && feeVal !== "") {
      fees[ind].name = feeLabel;
      fees[ind].value = feeVal;

      this.setState({ fees });
      this.props.updateTransactionData("otherEMD", fees);

      $(".other-emd-label .title input").val("");
      $(".other-emd-label .value input").val("");
      this.setState({ isEdit: false });
      this.props.updateTransactionData("updatedEMD", []);
    }
  }

  render() {
    let defaultValue = "";
    let defVal = "";

    if (this.props.getTransactionData().draftedEMD !== undefined) {
      defaultValue = this.props.getTransactionData().draftedEMD.name;
      defVal = this.props.getTransactionData().draftedEMD.value;
    }

    let label = this.state.isEdit ? this.state.editData.name : defaultValue;
    let val = this.state.isEdit ? this.state.editData.value : defVal;

    var stateDropDownValue = [];
    for (var key in StatesList) {
      var opt = (
        <option key={key} value={key}>
          {StatesList[key]}
        </option>
      );
      stateDropDownValue.push(opt);
    }

    let timeZoneList = this.props.timezoneList || [];

    return (
      <div className="admin-steps admin-content-area">
        <div className="container-custom">
          <Form className="form-sm form-admin">
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12} sm={12}>
                    <Row>
                      <Col xs={12} sm={6}>
                        <Form.Group controlId="">
                          <Form.Label>
                            Artwork Type<span className="text-danger"> *</span>
                          </Form.Label>
                          <div className="c-select">
                            <select
                              name="transactionType"
                              className="form-control"
                              value={this.state.transactionType}
                              onChange={this.onChange.bind(this)}
                              onBlur={this.props.handleValidation(
                                "transactionType"
                              )}
                            >
                              <option value="">Select</option>
                              {this.props.transactionType &&
                                this.props.transactionType.length > 0 &&
                                this.props.transactionType.map((option) => {
                                  return (
                                    <option
                                      value={option.name}
                                      key={option._id}
                                    >
                                      {option.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                          <Form.Text className="text-danger">
                            {this.renderHelpText(
                              this.getErrorMsg(
                                "transactionType",
                                this.props.errors
                              )
                            )}
                          </Form.Text>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6}>
                        <Form.Group controlId="">
                          <Form.Label>Description</Form.Label>
                          <textarea
                            class="form-control"
                            type="heldBy"
                            name="heldBy"
                            defaultValue={this.state.heldBy}
                            onChange={this.onChange.bind(this)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6}>
                        <Form.Group controlId="">
                          <Form.Label>
                            Total Cost<span className="text-danger"> *</span>
                          </Form.Label>

                          {this.state.salePriceFocus ? (
                            <NumericInput
                              name="agreedOpenPrice"
                              inputMode="numeric"
                              strict
                              step={0.1}
                              precision={2}
                              style={false}
                              className="form-control text-right sales-input"
                              value={
                                this.state.agreedOpenPrice
                                  ? this.state.agreedOpenPrice
                                  : ""
                              }
                              onChange={(e) => {
                                this.setState({ agreedOpenPrice: e });
                                this.props.updateTransactionData(
                                  "agreedOpenPrice",
                                  e
                                );
                              }}
                              onBlur={() => {
                                this.setState({ salePriceFocus: false });
                                this.props.handleValidation("agreedOpenPrice");
                              }}
                            />
                          ) : (
                            <Form.Control
                              type="text"
                              name="agreedOpenPrice"
                              className="text-right"
                              onFocus={() => {
                                this.setState({ salePriceFocus: true }, () => {
                                  $(".sales-input").focus();
                                });
                              }}
                              onMouseEnter={() => {
                                this.setState({ salePriceFocus: false });
                              }}
                              defaultValue={
                                this.state.agreedOpenPrice
                                  ? currencyFormat(this.state.agreedOpenPrice)
                                  : ""
                              }
                            />
                          )}

                          {this.state.agreedOpenPrice === "" ||
                          this.state.agreedOpenPrice === 0 ? (
                            <Form.Text className="text-danger">
                              {this.renderHelpText(
                                this.getErrorMsg(
                                  "agreedOpenPrice",
                                  this.props.errors
                                )
                              )}
                            </Form.Text>
                          ) : (
                            ""
                          )}
                        </Form.Group>
                      </Col>
                      {/* <Col xs={12} sm={6}>
                        <Form.Group controlId="">
                          <Form.Label>
                            Deposit<span className="text-danger"> *</span>
                          </Form.Label>
                          {this.state.emdFocus ? (
                            <input
                              type="number"
                              name="emd"
                              min={0}
                              className="form-control text-right emd-input"
                              placeholder="Enter Amount"
                              value={this.state.emd >= 0 ? this.state.emd : ""}
                              onChange={(e) => {
                                this.setState({ emd: e.target.value });
                                this.props.updateTransactionData(
                                  "emd",
                                  e.target.value
                                );
                              }}
                              onBlur={() => {
                                this.setState({ emdFocus: false });
                              }}
                              //   onBlur={() => {
                              //     this.setState({ emdFocus: false });
                              //     this.props.handleValidation("emd");
                              //   }}
                            />
                          ) : (
                            <Form.Control
                              type="text"
                              name="emd"
                              className="text-right"
                              onFocus={() => {
                                this.setState({ emdFocus: true }, () => {
                                  $(".emd-input").focus();
                                });
                              }}
                              defaultValue={
                                this.state.emd >= 0
                                  ? currencyFormat(this.state.emd)
                                  : ""
                              }
                            />
                          )}
                          {this.state.emd === "" ? (
                            <Form.Text className="text-danger">
                              {this.renderHelpText(
                                this.getErrorMsg("emd", this.props.errors)
                              )}
                            </Form.Text>
                          ) : this.state.emd > this.state.agreedOpenPrice ? (
                            <Form.Text className="text-danger">
                              {this.renderHelpText(
                                this.getErrorMsg("emd", this.props.errors)
                              )}
                            </Form.Text>
                          ) : (
                            ""
                          )}
                        </Form.Group>
                      </Col> */}
                    </Row>
                    <Row>
                      <Col xs={12} sm={6}>
                        <Form.Group controlId="">
                          <Form.Label>
                            Commission (%)
                            <span className="text-danger"> *</span>
                          </Form.Label>
                          <NumericInput
                            name="commission"
                            precision={2}
                            min={0}
                            max={100}
                            inputMode="numeric"
                            strict
                            style={false}
                            className="form-control"
                            value={this.state.commission}
                            onChange={(e) => {
                              this.setState({ commission: e });
                              this.props.updateTransactionData("commission", e);
                            }}
                            onBlur={this.props.handleValidation("commission")}
                            disabled={true}
                          />
                          <Form.Text className="text-danger">
                            {this.renderHelpText(
                              this.getErrorMsg("commission", this.props.errors)
                            )}
                          </Form.Text>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6}>
                        <Form.Group controlId="">
                          <Form.Label>
                            Artwork ID<span className="text-danger"> *</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="shortName"
                            value={this.state.shortName}
                            maxLength={10}
                            onChange={(event) => {
                              this.setState({
                                [event.target.name]: event.target.value,
                                nameBySystem: false,
                              });
                              this.props.updateTransactionData(
                                event.target.name,
                                event.target.value
                              );
                              this.props
                                .checkShortName(event.target.value)
                                .then((res) => {
                                  if (res.isAccepted) {
                                    this.setState({ shortNameAccepted: true });
                                  } else {
                                    this.setState({ shortNameAccepted: false });
                                  }
                                });
                            }}
                            onBlur={this.props.handleValidation("shortName")}
                            className=""
                            readOnly
                          />
                          <Form.Text className="text-danger">
                            {this.renderHelpText(
                              this.getErrorMsg("shortName", this.props.errors)
                            )}
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>

                    <BrokerageFees
                      isCreate={true}
                      addCls={true}
                      profileData={this.props.profileData}
                      salePrice={this.state.agreedOpenPrice}
                      commission={this.state.commission}
                      getTransactionData={this.props.getTransactionData}
                      updateTransactionData={this.props.updateTransactionData}
                    />

                    <Row>
                      <Col xs={12} sm={6}>
                        <Form.Group controlId="">
                          <Form.Label>Timezone</Form.Label>
                          <div className="c-select">
                            <select
                              name="userTimezone"
                              className="form-control"
                              value={this.state.userTimezone}
                              onChange={this.onChange.bind(this)}
                            >
                              {timeZoneList.map((e) => {
                                return (
                                  <option key={e._id} value={e.value}>
                                    {e.displayText}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={5}>
                <Form.Group
                  controlId=""
                  className="dropzone-transaction-wrapper"
                >
                  <div className="mt-4">
                    <Dropzone
                      accept="image/*"
                      maxSize={100000000}
                      onDrop={(acceptedFiles) => {
                        this.uploadImage(acceptedFiles);
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <div
                            className="dropzone-transaction"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <CropOriginal />
                            <p>
                              <strong>Choose a file</strong> or drag here
                            </p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                  </div>
                  <div className="dropzone-list">
                    <ul>
                      {this.state.acceptedFiles.map((file, i) => {
                        return (
                          <li key={i} className="email-case">
                            {typeof file === "string"
                              ? file
                              : file != null
                              ? file.name
                              : ""}
                            <Button
                              variant="transparent"
                              onClick={() => {
                                this.deleteImage(i);
                              }}
                            >
                              <DeleteOutline />
                            </Button>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  <Form.Text className="text-danger">
                    {this.renderHelpText(
                      this.getErrorMsg("property_image", this.props.errors)
                    )}
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

export default validation(strategy)(PropertyInfo);
